export const SIGN_UP_PROCESS_STEP = {
  COLLECT_BASIC_INFO: "COLLECT_BASIC_INFO",
  VERIFY_PHONE_NUMBER: "VERIFY_PHONE_NUMBER",
  REQUEST_BROKER_ACCESS: "REQUEST_BROKER_ACCESS",
  CONNECT_BANK: "CONNECT_BANK",
  RETRIEVE_BANK_DATA: "RETRIEVE_BANK_DATA",
  CONNECT_PROPERTY: "CONNECT_PROPERTY",
  SET_BUYING_GOAL: "SET_BUYING_GOAL",
  SIGN_UP_SUCCESS: "SIGN_UP_SUCCESS",
};

export const SIGN_UP_COLLECT_BASIC_INFO_STEP = {
  FIRST_NAME: 0,
  LAST_NAME: 1,
  PHONE_NUMBER: 2,
  EMAIL: 3,
  PASSWORD: 4,
  DONE: 5,
};
